import { Component, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';

import { Observable } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';

import { ContratoService } from '../../../../providers/contrato-service';
import { ContratosGestaoService } from '../../../../providers/contratos-gestao-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { FileService } from '../../../../providers/file-service';

import { ContasBancariasService } from '../../../../providers/contas-bancarias-service';

import { ModalArquivosPage } from "../../../modais/modal-arquivos/modal-arquivos";

import createNumberMask from 'text-mask-addons/dist/createNumberMask'

declare var jsPDF: any;

@Component({
    selector: 'page-relatorio-receitas-despesas',
    templateUrl: 'relatorio-receitas-despesas.html',
    providers: [
        ContratosGestaoService
    ]
})
export class RelatorioReceitasDespesasPage extends ModulosController {
    listaDados: any = [];
    listaBancos: any = [];
    listaContratos: any = [];
    listaContratosAux: any = [];
    loading: boolean = true;
    idSecaoPagina: string = "146";
    tiposArquivosAceitos: string = "application/xls";
    dadosImportados: any[];

    numberMask = createNumberMask({
        prefix: '',
        suffix: '', // This will put the dollar sign at the end, with a space.
        thousandsSeparatorSymbol: '',
        allowDecimal: false,
        decimalSymbol: ',',
        allowLeadingZeroes: true
    });

    relatorioParaAdicionar: any = {
        nmContrato: '',
        credor: '',
        recursosRecebidos: '',
        restituicoes: '',
        transferencias: '',
        rendAcumulados: '',
        outrasReceitas: '',
        despesasPeriodo: '',
        despesasFinanceiras: ''
    }

    page1: number = 1;

    pagination = {
        TotalItems: 100,
        CurrentPage: 1,
        PageSize: 10,
        TotalPageLinkButtons: 5,
        RowsPerPageOptions: [10]
    };

    searchLoading: boolean = true;

    typeahead = new EventEmitter<string>();

    objetoEdit: any = null;
    listEdit: any = [];
    codigoModulo: any = 0;
    comboContratos: any = null;
    analise: any = null;

    @ViewChild('inputFileCM')
    inputFileCMVar: ElementRef;

    desabilitarImportacao = true;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public contratoService: ContratoService,
        public contratosGestaoService: ContratosGestaoService,
        private fileService: FileService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService,
        public contasBancariasService: ContasBancariasService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

        this.analise = this.navParams.get('analise');

        if (this.isJurisdicionado) {
            this.codigoModulo = this.navParams.get('analise').idModuloPca;
          }

        this.carregarDados();
        this.setModuloId(14);

        //this.typeahead
        //    .pipe(distinctUntilChanged(), debounceTime(200), switchMap(term => this.buscarContratos(term)))
        //    .subscribe(items => {
        //        this.listaContratos = items;
        //    }, (err) => {
        //        console.log(err);
        //        this.listaContratos = [];
        //    });
    }

    carregarDados() {
      /*  this.contratosGestaoService.obterAnalise(this.idSecaoPagina).subscribe(data => {
            this.listaDados = data;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });*/

        this.desabilitarImportacao = true;
        
        this.loading = true;
        this.contratosGestaoService.obterAnalisePag(1, this.idSecaoPagina).subscribe(data => {
            this.listaDados = data.analises;
            this.loading = false;
            this.pagination.TotalItems = data.qtdPags;
            this.desabilitarImportacao = this.listaDados.length > 0;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });

        this.searchLoading = true;
        this.contratosGestaoService.obterContratosGestao().subscribe(data => {
            this.listaContratos = data;
            this.searchLoading = false;
        }, error => {
            console.log("erro: " + error);
            this.searchLoading = false;
        });
    }

    buscarContratos(term: string): Observable<any[]> {
        return this.contratosGestaoService.obterContratosGestaoPorNumero(term);
    }

    fileChange(event) {
        this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
            if (callback) {                
                this.loading = true;
                this.fileService.cargaAnalises(event, this.idSecaoPagina).subscribe(data => {
                    this.inputFileCMVar.nativeElement.value = "";
                    this.dadosImportados = data;

                    for (let j = 0; j < this.dadosImportados.length; j++) {
                        if (this.listaDados.findIndex(i => {return i.contratoGestao.nmContrato === this.dadosImportados[j].contratoGestao.nmContrato}) != -1) {
                            this.alertService.mostraAlerta("Importação interrompida.", "Contrato de Gestão " + this.dadosImportados[j].contratoGestao.nmContrato + " já adicionado!");
                            this.loading = false;
                            return;
                        }
                        this.listaDados.push(this.dadosImportados[j]);
                    }

                    this.alertService.mostraAlerta("Importação concluída.","Para efetivar a importação, clique em salvar ou finalizar.");
                    this.loading = false;
                }, error => {
                    this.inputFileCMVar.nativeElement.value = "";
                    this.alertService.mostraAlerta("Houve um erro ao carregar o arquivo.", error.mensagem);
                    this.loading = false;
                });
            } else {
                this.inputFileCMVar.nativeElement.value = "";
            }
        });
    }

    downloadDoModelo() {
        this.fileService.downloadModeloCargaContratoGestao(this.idSecaoPagina);
    }

    adicionarRelatorio() {

        if (this.relatorioParaAdicionar.restituicoes == '') {
            this.relatorioParaAdicionar.restituicoes = 0;
        }
        if (this.relatorioParaAdicionar.transferencias == '') {
            this.relatorioParaAdicionar.transferencias = 0;
        }
        if (this.relatorioParaAdicionar.rendAcumulados == '') {
            this.relatorioParaAdicionar.rendAcumulados = 0;
        }
        if (this.relatorioParaAdicionar.outrasReceitas == '') {
            this.relatorioParaAdicionar.outrasReceitas = 0;
        }
        
        if (this.relatorioParaAdicionar.nmContrato !== '' &&
            this.relatorioParaAdicionar.recursosRecebidos !== '' &&
            this.relatorioParaAdicionar.despesasPeriodo !== '' &&
            this.relatorioParaAdicionar.despesasFinanceiras !== '') {

            let relatorioNovo = {
                "id": 0,
                "idModuloAnalise": 0,
                "contratoGestao": {
                    "id": 0,
                    "nmContrato": this.relatorioParaAdicionar.nmContrato,
                    "credor": "",
                    "cpf": "",
                    "cnpj": "",
                    "objeto": "",
                    "dataAssinatura": "",
                    "inicioVigencia": "",
                    "fimVigencia": "",
                    "dataPublicacao": "",
                    "valorInicial": 0,
                    "responsavel": "",
                    "novaDataVigencia": "",
                    "valorAtual": 0,
                    "aditivos": [],
                    "flCertificado": false,
                    "situacao": "",
                    "dtPrazoPublicacao": "",
                    "diasForaDoPrazo": "",
                    "codSituacao": 0,
                    "arquivos": []
                },
                "dsMetas": "",
                "dsAtividade": "",
                "quantidadePrevista": 0,
                "valorUnitarioPrevisto": 0,
                "totalPrevisto": 0,
                "quantidadeRealizada": 0,
                "valorUnitarioRealizado": 0,
                "totalRealizado": 0,
                "recursosRecebidos": this.relatorioParaAdicionar.recursosRecebidos,
                "restituicoes": this.relatorioParaAdicionar.restituicoes,
                "transferencias": this.relatorioParaAdicionar.transferencias,
                "rendAcumulados": this.relatorioParaAdicionar.rendAcumulados,
                "outrasReceitas": this.relatorioParaAdicionar.outrasReceitas,
                "despesasPeriodo": this.relatorioParaAdicionar.despesasPeriodo,
                "despesasFinanceiras": this.relatorioParaAdicionar.despesasFinanceiras,
                "tipoDespesa": "",
                "naturezaDespesa": "",
                "numeroCheque": "",
                "dataEmissao": "",
                "dataPagamento": "",
                "valorDocumento": 0,
                "valorPago": 0,
                "numeroEditalCotacao": "",
                "dataEditalCotacao": "",
                "exercicio": "",
                "valorRetirado": 0,
                "dataRetornoRecurso": "",
                "valorRetorno": 0,
                "valorCorrecao": 0,
                "justificativa": "",
                "destinacaoValor": "",
                "prazoReposicao": "",
                "orgSocial": "",
                "nomePessoa": "",
                "dataAdmissao": "",
                "dataDesligamento": "",
                "funcaoDesenvolvida": "",
                "cpf": "",
                "valorJaneiro": 0,
                "valorFevereiro": 0,
                "valorMarco": 0,
                "valorAbril": 0,
                "valorMaio": 0,
                "valorJunho": 0,
                "valorJulho": 0,
                "valorAgosto": 0,
                "valorSetembro": 0,
                "valorOutubro": 0,
                "valorNovembro": 0,
                "valorDezembro": 0,
                "totalExercicio": 0
            };

            // let tipoVinculoTemp = this.listaContratosAux.filter((contrato) => this.relatorioParaAdicionar.nmContrato == contrato.nmContrato)[0];

            this.contratoService.obterPorNumeroContrato(this.relatorioParaAdicionar.nmContrato).subscribe(data => {
                if (data != null) {
                    relatorioNovo.contratoGestao.id = data.id;
                    relatorioNovo.contratoGestao.nmContrato = data.nmContrato;
                    relatorioNovo.contratoGestao.credor = data.credor;
                    relatorioNovo.contratoGestao.cpf = data.cpf;
                    relatorioNovo.contratoGestao.cnpj = data.cnpj;
                    relatorioNovo.contratoGestao.objeto = data.objeto;
                    relatorioNovo.contratoGestao.dataAssinatura = data.dataAssinatura;
                    relatorioNovo.contratoGestao.inicioVigencia = data.inicioVigencia;
                    relatorioNovo.contratoGestao.fimVigencia = data.fimVigencia;
                    relatorioNovo.contratoGestao.dataPublicacao = data.dataPublicacao;
                    relatorioNovo.contratoGestao.valorInicial = data.valorInicial;
                    relatorioNovo.contratoGestao.responsavel = data.responsavel;
                    relatorioNovo.contratoGestao.novaDataVigencia = data.novaDataVigencia;
                    relatorioNovo.contratoGestao.valorAtual = data.valorAtual;
                    relatorioNovo.contratoGestao.aditivos = data.aditivos;
                    relatorioNovo.contratoGestao.flCertificado = data.flCertificado;
                    relatorioNovo.contratoGestao.situacao = data.situacao;
                    relatorioNovo.contratoGestao.dtPrazoPublicacao = data.dtPrazoPublicacao;
                    relatorioNovo.contratoGestao.diasForaDoPrazo = data.diasForaDoPrazo;
                    relatorioNovo.contratoGestao.codSituacao = data.codSituacao;
                    relatorioNovo.contratoGestao.arquivos = data.arquivos;
                } else {
                    this.alertService.mostraAlerta("", "Contrato não encontrado!");
                    return;
                }

                if (this.listaDados.findIndex(i => {return i.contratoGestao.nmContrato === relatorioNovo.contratoGestao.nmContrato}) != -1 
                    && !this.objetoEdit) {
                    this.alertService.mostraAlerta("", "Contrato de Gestão já adicionado!");
                } else {

                    if (this.objetoEdit) {
                        let index = this.listaDados.indexOf(this.objetoEdit);
                        this.listaDados.splice(index, 1);

                        this.listEdit.push(this.objetoEdit);
                    }

                    this.listaDados.push(relatorioNovo);

                    this.objetoEdit = null;

                    this.relatorioParaAdicionar.nmContrato =
                        this.relatorioParaAdicionar.credor =
                        this.relatorioParaAdicionar.recursosRecebidos =
                        this.relatorioParaAdicionar.restituicoes =
                        this.relatorioParaAdicionar.transferencias =
                        this.relatorioParaAdicionar.rendAcumulados =
                        this.relatorioParaAdicionar.outrasReceitas =
                        this.relatorioParaAdicionar.despesasPeriodo =
                        this.relatorioParaAdicionar.despesasFinanceiras = '';

                    this.comboContratos = null;
                }
            }, error => {
                console.log("erro: " + error);
                this.searchLoading = false;
            });
        }

    }

    onContratoChange(contrato) {

        if (contrato != null && contrato != undefined) {
            this.relatorioParaAdicionar.nmContrato = contrato.nmContrato;
            this.relatorioParaAdicionar.credor = contrato.dsCredor;
        } else {
            this.relatorioParaAdicionar.nmContrato = '';
        }
    }

    removerRelatorio(item, edit) {
        if (!edit) {
            this.alertService.mostraModalConfirmacao("Remover Item", "Deseja remover o item?", callback => {
                if (callback) {

                    let index = this.listaDados.indexOf(item);
                    this.listaDados.splice(index, 1);

                    if (item.id != 0) {
                        this.deletarRelatorio(item.id, edit);
                    }
                }
            });
        } else {
            // let index = this.listaDados.indexOf(item);
            // this.listaDados.splice(index, 1);

            if (item.id != 0) {
                this.deletarRelatorio(item.id, edit);
            }
        }
    }

    formatarValorNumerico(valor) {
        if(isNaN(valor))
        {
            valor = 0;
        }
        
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaContratosGestao() {
        this.menuService.redirecionarPagina(this.contratosGestaoService.obterIdPaginaContratosGestao());
    }

    salvar() {

        this.listEdit.forEach(item => {
            this.removerRelatorio(item, true);
        });

        this.listEdit = [];

        this.contratosGestaoService.salvarAnalise(this.listaDados, this.idSecaoPagina).subscribe(data => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
            this.carregarDados();
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
        })
    }

    deletarRelatorio(idContratoGestao, edit) {
        this.contratosGestaoService.deletarAnalise(idContratoGestao, this.idSecaoPagina).subscribe(data => {
            if (!edit) {
                this.alertService.mostraAlerta("", "Removido com sucesso.");
            }
        }, error => {
            this.alertService.mostraAlerta("Erro ao excluir", "O registro pode estar vinculado a outra análise no sistema.");
            this.carregarDados();
        })
    }

    finalizar() {

        this.listEdit.forEach(item => {
            this.removerRelatorio(item, true);
        });

        this.listEdit = [];

        if (this.listaDados) {
            this.contratosGestaoService.finalizarAnalise(this.listaDados, this.idSecaoPagina).subscribe(data => {
                this.alertService.mostraAlerta("", "Finalizado com sucesso.");
                this.voltarParaContratosGestao();
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error);
            });
        }
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 10;

        if (text != undefined) {
            let separatedByWords = text.toString().split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.toString().split(" ");
        let numberOfWordsToTruncate = 10;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    editar(item) {
        this.comboContratos = item.contratoGestao.nmContrato;
        this.relatorioParaAdicionar.nmContrato = item.contratoGestao.nmContrato;
        this.relatorioParaAdicionar.credor = item.contratoGestao.credor;
        this.relatorioParaAdicionar.recursosRecebidos = item.recursosRecebidos;
        this.relatorioParaAdicionar.restituicoes = item.restituicoes;
        this.relatorioParaAdicionar.transferencias = item.transferencias;
        this.relatorioParaAdicionar.rendAcumulados = item.rendAcumulados;
        this.relatorioParaAdicionar.outrasReceitas = item.outrasReceitas;
        this.relatorioParaAdicionar.despesasPeriodo = item.despesasPeriodo;
        this.relatorioParaAdicionar.despesasFinanceiras = item.despesasFinanceiras;

        this.objetoEdit = item;
    }

    printData() {

        var doc = new jsPDF("l");
        var totalPagesExp = "{total_pages_count_string}";

        var pageContent = function (data) {
            // HEADER
            doc.setFontSize(20);
            doc.setTextColor(40);
            doc.setFontStyle('normal');

            doc.text("Relatório de Execução da Receita e Despesa", data.settings.margin.left + 15, 22);

            // FOOTER
            var str = "Page " + data.pageCount;
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
                str = str + " of " + totalPagesExp;
            }
            doc.setFontSize(10);
            doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
        };

        var columns = [
            { title: "Nº Contrato SAC/SCC", dataKey: "contrato" },
            { title: "Organização Social", dataKey: "org" },
            { title: "Recursos Recebidos", dataKey: "recRec" },
            { title: "Restituições", dataKey: "rest" },
            { title: "Transferências", dataKey: "trans" },
            { title: "Rendimentos Acum.", dataKey: "rendAc" },
            { title: "Outras Receitas", dataKey: "out" },
            { title: "Despesas Período", dataKey: "per" },
            { title: "Despesas Financeiras", dataKey: "fin" }
        ];

        let rows = [];

        this.listaDados.forEach(contrato => {

            var item = {
                "contrato": contrato.contratoGestao.nmContrato,
                "org": contrato.contratoGestao.credor,
                "recRec": this.formatarValorNumerico(contrato.recursosRecebidos),
                "rest": this.formatarValorNumerico(contrato.restituicoes),
                "trans": this.formatarValorNumerico(contrato.transferencias),
                "rendAc": this.formatarValorNumerico(contrato.rendAcumulados),
                "out": this.formatarValorNumerico(contrato.outrasReceitas),
                "per": this.formatarValorNumerico(contrato.despesasPeriodo),
                "fin": this.formatarValorNumerico(contrato.despesasFinanceiras)
            };

            rows.push(item);
        });

        doc.autoTable(columns, rows, {
            theme: 'grid',
            addPageContent: pageContent,
            margin: { top: 30 },
            styles: {
                overflow: 'linebreak',
                columnWidth: 'auto',
                fontSize: 8
            },
            columnStyles: {
                desc: { columnWidth: 'auto' }
            }
        });

        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }

        doc.save('relatorio_receitas_despesas.pdf');
    }

    modalEvidencias(item: any) {

        let titulo = "Evidências";

        let modal = this.modalCtrl.create(ModalArquivosPage,
            {
                titulo: titulo,
                IdProcesso: item.contratoGestao.nmContrato,
                idModuloPCA: this.codigoModulo,
                tipoAnalise: 0,
                jurisdicionado: this.isJurisdicionado,
                isCGE: this.isCGE,
                origemArquivo: "Processo: " + item.contratoGestao.nmContrato,
                tipoEntidadeExercicio: 0,
                tipodocumento: 0,
                analise: this.analise
            });

        modal.present();

    }

    loadPage(Page: number) {
        this.pagination.CurrentPage = Page;
        this.loading = true;
        this.contratosGestaoService.obterAnalisePag(Page, this.idSecaoPagina).subscribe(data => {
          this.listaDados =  data.analises;
          this.loading = false;
          this.pagination.TotalItems = data.qtdPags;
        }, error => {
          console.log("erro: " + error.mensagem);
          this.loading = false;
        });
      }
    
      deletarTodos(){
        this.alertService.mostraModalConfirmacao("Excluir os registros", "Deseja excluir " + this.pagination.TotalItems + " registro(s)?", callback => {
            if (callback) {
                this.loading = true;
                this.contratosGestaoService.deletarTodos(this.idSecaoPagina).subscribe(data => {
                    this.alertService.mostraAlerta("Exclusão concluída","Todos os registros foram excluídos.");
                    this.carregarDados();
                }, error => {
                    console.log("erro: " + error);
                    this.alertService.mostraAlerta("Erro ao excluir", "Algum registro pode estar vinculado a outra análise no sistema.");
                    this.carregarDados();                   
                });
            }
        });        
      }

      importarDoAnoAnterior() {

        this.alertService.mostraModalConfirmacao("Importar do Ano Anterior", 
            "Recomenda-se realizar a importação dos dados por meio do template de carga em massa."+
            "<br />Deseja continuar a importação dos registros do ano anterior mesmo assim?", 
            callback => {            
                if (callback) {
                    this.loading = true;
                    this.desabilitarImportacao = true;
                    this.contratosGestaoService.carregarAnoAnterior(this.idSecaoPagina).subscribe(data => {
                        this.alertService.mostraAlerta("", data.mensagem);
                        this.carregarDados();
                    }, error => {
                        console.log("erro: " + error.mensagem);
                        this.alertService.mostraAlerta("Erro ao importar", error.mensagem);
                        this.carregarDados();
                    });
                }
            }
        );

    }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos-gestao/relatorio-receitas-despesas/relatorio-receitas-despesas.ts